import { render, staticRenderFns } from "./startingAddress.vue?vue&type=template&id=76d13c6d&"
import script from "./startingAddress.vue?vue&type=script&lang=js&"
export * from "./startingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports